import React from 'react';
import FILTER_PARAMS from '@/constants/constituents/FilterParams';
import SortableFields from '@/constants/constituents/SortableFields';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import { useCustomFieldsWithFilterParams } from '@/modules/CustomFieldFilters';
import QueryProvider, {
  type QueryProviderProps,
} from '@/modules/QueryProvider';
import type ConstituentSearchFilterParams from '../types/ConstituentSearchFilterParams';

function ConstituentSearchQueryProvider({
  children,
  ...rest
}: {
  children: React.ReactNode;
} & Omit<QueryProviderProps, 'filterParams' | 'sortableFields'>) {
  const filterParams = useCustomFieldsWithFilterParams(FILTER_PARAMS);

  return (
    <QueryProvider<ConstituentSearchFilterParams>
      filterParams={filterParams}
      sortableFields={SortableFields}
      {...rest}
    >
      {children}
    </QueryProvider>
  );
}

export default ConstituentSearchQueryProvider;
